import { __, Alert } from 'modules/theme';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import APIManager from 'modules/common/apiManager';
import Select from 'react-select-plus';
import {
  FormControl,
  FormGroup,
  ControlLabel,
  ModalFooter,
  FormWrapper,
  FormColumn,
  ButtonCommonTheme,
} from 'modules/theme';
import { ModalForm, ModalFormContainer } from '../../../../theme/theme1/common/styles/main';


class NlpAgentAddEdit extends Component {
  constructor(props) {
    super(props);

    this.saveData = this.saveData.bind(this);
    this.renderFormGroup = this.renderFormGroup.bind(this);

    this.mAPI = new APIManager();
    if (this.props.editData && this.props.editData._id) {
      this.state = {
        name: this.props.editData.name,
        language: this.props.editData.language,
        isEdit: true,
       };
    } else {
      this.state = {
        name: '',
        language: "",
        isEdit: false,
      };
    }
  }

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        <ControlLabel required={props.required}>{label}</ControlLabel>
        <FormControl {...props} />
      </FormGroup>
    );
  }

  resetAllData() {
    this.setState({
     name: '',
     type: '',
    });
  }

  apiResponse(errorCode, data) {
    if (errorCode === 201) {
      // Alert.success(`${data.message}`);
      let message = data && data.message ? data.message : 'Successfully Done';
      Alert.success(`${message}`);
      this.resetAllData();
      this.props.closeModal(true);
    } else {
      // Alert.error(`${data.message}`);
      let message = data && data.message ? data.message : 'Something wrong happened';
      Alert.error(`${message}`);
    }
  }
  saveData(e) {
    let _this = this;
    e.preventDefault();
    this.props.clearSearchField();
    let name = this.state.name.trim();
    let tData = {
      name: name,
      language: this.state.language
    };

    if (this.props.editData && this.props.editData._id) {
      this.mAPI.sendPostAPI(
        `setting/nlp-agent/${this.props.editData._id}`,
        tData,
        data => {
          console.log(JSON.stringify(data, null, 2));
          if (data) {
            _this.resetAllData();
            _this.props.closeModal(true);
            Alert.success(`Name ${tData.name} is Updated.`);
          }
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        },
        'private',
        { id: tData._id },
        'PUT'
      );
    } else {
      this.mAPI.sendPostAPI(
        'setting/nlp-agent',
        tData,
        data => {
          if (data && data.message) {
            Alert.success(`${data.message}`);
          } else {
            Alert.success(`Successfully Added`);
          }
          this.resetAllData();
          this.props.update();
          this.props.closeModal(true);
        },
        (errorCode, data) => {
          this.apiResponse(errorCode, data);
        }
      );
    }
  }

  render() {
    const { __ } = this.context;
    const { modalType } = this.props;
    console.log('infoData', this.props.infoData);
    return (
      <ModalForm onSubmit={e => this.saveData(e)}>
      <ModalFormContainer>
        <FormWrapper>
          <FormColumn>
            {this.renderFormGroup('Name', {
              placeholder:'Name',
              defaultValue: '',
              autoFocus: true,
              required: true,
              id: 'name',
              value: this.state.name,
              onChange: e => {
                let value = e.target.value || "";
                if( value.length > 50 ){
                  return false;
                }
                this.setState({ name: value });
              }
            })}
          </FormColumn>
        </FormWrapper>
        <FormWrapper style={{marginBottom:"30px"}}>
          <FormColumn>
            <ControlLabel>Language</ControlLabel>
            <Select
              key={`language`}
              placeholder={__('Choose language')}
              value={this.state.language}
              options={[
                { value: 'en', label: 'English' }
              ]}
              // onFocus={() => users.length < 1 && this.handleUserSearch('')}
              // onInputChange={this.handleTeam}
              onChange={value => {
                const selected = value && value.value ? value.value : '';
                this.setState({ language: selected });
              }}
              multi={false}
            />
          </FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn></FormColumn>
        </FormWrapper>
        <FormWrapper>
          <FormColumn></FormColumn>
        </FormWrapper>
        </ModalFormContainer>
        <ModalFooter modalType={modalType}>
          <ButtonCommonTheme btnSize='medium' type='greyModalBtn' modalBtnTitle='Cancel' OnClick={() => { this.props.closeModal() }} />
          <ButtonCommonTheme type='blueModalBtn' btnType='submit' modalBtnTitle={this.props.editData && this.props.editData._id ? 'Update' : 'Add'} />
        </ModalFooter>
      </ModalForm>
    );
  }
}

NlpAgentAddEdit.propTypes = {
  group: PropTypes.array
};

NlpAgentAddEdit.contextTypes = {
  __: PropTypes.func
};

export default NlpAgentAddEdit;



// WEBPACK FOOTER //
// src/modules/screens/settings/NlpAgent/components/NlpAgentAddEdit.js